// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"style_scrollWrapper__lRbnF","footer":"style_footer__-ze3w","arrow":"style_arrow__5CGNy","prev":"style_prev__zLVUk"};